<template>
    <div class="layout-footer">
        <div @click="handleClick(item)" :class="{ active: item.path === $route.meta.name }" v-for="item in menus">
            <img :src="item.path === $route.meta.name ? item.activeIcon : item.icon" alt=""></img>

            <span>{{ item.title }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'layout-footer',
    data() {
        return {
        }
    },
    computed: {
        menus() {
            return [
                {
                    icon: require('../assets/img/layout/icon-home.png'),
                    activeIcon: require('../assets/img/layout/icon-home-active.png'),
                    title: this.$t('menu.home'),
                    path: 'home',
                },
                {
                    icon: require('../assets/img/layout/icon-mining.png'),
                    activeIcon: require('../assets/img/layout/icon-mining-active.png'),
                    title: this.$t('menu.mining'),
                    path: 'mining',
                    active: true
                },
                {
                    icon: require('../assets/img/layout/icon-wallet.png'),
                    activeIcon: require('../assets/img/layout/icon-wallet-active.png'),
                    title: this.$t('menu.wallet'),
                    path: 'wallet',
                    active: true
                },
                {
                    icon: require('../assets/img/layout/icon-me.png'),
                    activeIcon: require('../assets/img/layout/icon-me-active.png'),
                    title: this.$t('menu.me'),
                    path: 'me',
                    active: true
                }
            ]
        }
    },
    mounted() {

    },
    methods: {
        handleClick(item) {
            if (!item.path) return;
            this.$router.push(item.path)
        }
    },

}
</script>

<style lang="less">
.layout-footer {
    position: fixed;
    height: 60px;
    max-width: 375px;
    display: flex;
    bottom: 16px;
    width: 335px;
    left: 50%;
    transform: translateX(-50%);
    background: url('../assets/img/layout/footer-bg.png') no-repeat;
    background-size: 100% 100%;
    align-items: center;
    -webkit-backdrop-filter: blur(17px);
    backdrop-filter: blur(17px);
    border-radius: 30px;
    &::before{
        content: ' ';
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    background: url('../assets/img/layout/footer-bg1.png') no-repeat;
    background-size: 100% 100%;
    align-items: center;
    }
    >div {
        position: relative;
        z-index: 2;
        flex: 1;
        // justify-content: center;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        img {
            width: 24px;
            height: 24px;
            margin-bottom: 6px;
        }

        span {
            color: #fff;
            font-size: 12px;
            opacity: 0.6;
            line-height: 16px;
        }



        &.active {
            padding-top: 0;

            span {
                opacity: 1;
                color: #05B9D0;
            }
        }
    }
}
</style>